import bg2 from '../../imgs/test2.avif'

import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import './home.scss'

function Home() {
  const { t } = useTranslation()

  useEffect(() => {
    document.title = 'Dwain | Software Developer Portfolio'
  }, [])

  return (
    <main className='page-home'>
      <div className='bg-img' style={{ backgroundImage: `url(${bg2})` }} role="presentation" aria-hidden="true"/>
      <header className='home-title'>
        <h1 className='title-text'>{t('home.title')}</h1>
        <p className='title-subText'>{t('home.subTitle')}</p>
      </header>
      <section className='home-counter' aria-label="Statistics">
        <article className='counter-item'>
          <div className='item-count' aria-label="Experience count">{t('home.counter.experience.count')}</div>
          <h2 className='item-title'>{t('home.counter.experience.title')}</h2>
        </article>
        <article className='counter-item'>
          <div className='item-count' style={{ fontSize: '18px' }} aria-label="Coding experience count">{t('home.counter.codeExperience.count')}</div>
          <h2 className='item-title'>{t('home.counter.codeExperience.title')}</h2>
        </article>
        <article className='counter-item'>
          <div className='item-count' aria-label="Projects count">{t('home.counter.projects.count')}</div>
          <h2 className='item-title'>{t('home.counter.projects.title')}</h2>
        </article>
      </section>
    </main>
  )
}

export default Home
